<template>
  <div style="width: 100%;height: 100%">
    <el-row :data="data">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：{{ data[0].GYS_NAME }}</li>
          <li>供&nbsp;&nbsp;&nbsp;&nbsp;应&nbsp;&nbsp;&nbsp;&nbsp;商：{{ data[0].SUPPLIER_NAME }}</li>
          <li>地址：{{ data[0].PROJECT_ADDRESS }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期&nbsp;：{{ data[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>联系电话：{{ data[0].GYS_TELPHONE }}</li>
          <li>制&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;人：{{ managername }}</li>
          <li>订&nbsp;单&nbsp;编&nbsp;号&nbsp;：{{ data[0].ORDER_CODE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="45" min-width="30"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="NEED_COUNT" label="送货数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="REAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-download" @click="downloadBatchReport(scope.row)"
                :disabled="scope.row.BATCH_REPORT_ID == 0">
                下载批次报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row :data="data">
      <el-col>
        <p>收货时间：</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <p>送货员：</p>
      </el-col>
      <el-col :span="6">
        <p>项目经理：</p>
      </el-col>
      <el-col :span="6">
        <p>厨师长：</p>
      </el-col>
      <el-col :span="6">
        <p>验收人员：</p>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;display: flex;">
      <el-col>
        <el-steps :active="this.statusFlag" finish-status="success" v-show="this.statusFlag !== 0" :space="200">
          <el-step :title="item.T" :description="item.D" v-for="item in checkData" :key="item.value"></el-step>
        </el-steps>
        <h4 v-show="this.statusFlag === 0" style="color:#E6A23C">暂无流程记录信息</h4>
      </el-col>
      <el-col :span="2">
        <el-button size="small" style="margin-right: 20px;margin-top: 30px" type="primary"
          v-if="this.USE_PRINT_TEMPLATE == 0" @click="openPreviewDialog">
          打印预览</el-button>
        <el-button size="small" v-if="this.USE_PRINT_TEMPLATE == 1" style="margin-right: 20px;margin-top: 30px"
          type="primary" @click="openPreviewDialog">
          打印预览</el-button>
      </el-col>
    </el-row>
    <el-dialog title="是否打印价格" center :visible.sync="previewVisible" width="400px">
      <el-radio style="margin: 0px 80px 0 90px" v-model="carryPrice" label="1">是</el-radio>
      <el-radio v-model="carryPrice" label="0">否</el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAll">取 消</el-button>
        <el-button @click="preview" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { supplierCusHisDetailFun } from 'api/sellOrder';

import { getActionFun } from 'api/login';
import http from '../../assets/common/http';
import bus from '@/assets/common/bus';

export default {
  data () {
    return {
      fromName: ['supplierCusOrderPrint', 'sellOrderSupplierPrintDetail', 'HistoryOrderList'],
      toName: ['supplierCusOrderPrint', 'sellOrderSupplierPrintDetail'],
      loading: false,
      managername: sessionStorage.getItem('name'),
      tableData: [],
      name: '',
      data: [
        {
          SUPPLIER_NAME: '',
          PROJECT_ADDRESS: '',
          ORDER_CODE: '',
          PROJECT_NAME: '',
          SEND_DAY: '',
          PROJECT_TELPHONE: '',
          DK_NAME: '',
        },
      ],
      USE_PRINT_TEMPLATE: 0,
      printStatus: '',
      formLabelWidth: '100px',
      editFormVisible: false,
      editForm: {},
      companyID: Number(sessionStorage.getItem('tcId')),
      ORDER_ID: sessionStorage.getItem('orderId'),
      ORDER_DETAIL_ID: '',
      checkData: [],
      statusFlag: 0,
      editAllFormVisible: false,
      editAllForm: {},
      Editname: '',
      addPoint: 0,
      PAGE_ID: '1000201', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 100020101: 0 },
      previewVisible: false,
      carryPrice: '0',
    };
  },
  methods: {
    // --------------------------------查看订单详情
    queryOrderDetailListData () {
      const params = {
        ID: Number(this.ORDER_ID),
        IS_SUPPLIER_CLIENT: 1,
        INCLUDE_THIRD_PARTY: 1,
      };
      supplierCusHisDetailFun(params).then((result) => {
        this.tableData = result.length > 0 ? result[0].list : [];
        this.data = result.length > 0 ? result[0].title : [];
        // ---------------------------------------获取判断的companyID
        this.companyID = result[0].title[0].TC_ID;
        this.addPoint = result[0].title[0].ADD_POINT;
        this.checkData = result[0].OR[0].DATA;
        this.statusFlag = result[0].OR[0].RN;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openPreviewDialog () {
      // this.previewVisible = true;
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        GYS_ID: this.data[0].GYS_ID,
        IS_SUPPLIER_CLIENT: 1,
      };
      http.post(params).then((result) => {
        sessionStorage.setItem('orderPrintStatus', 4);
        if (result[0].USE_PRINT_TEMPLATE == 1) {
          this.$router.push({ name: 'sellOrderSupplierPrintDetail' });
          sessionStorage.setItem('TEM_GYSID', this.data[0].GYS_ID);
        } else {
          this.previewVisible = true;
        }
        // this.form = result.TEMPLATE_CONTENT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeAll () {
      this.previewVisible = false;
    },
    // 供应商客户打印
    preview () {
      this.$router.push({ name: 'supplierCusOrderPrint' });
      sessionStorage.setItem('carryPrice', this.carryPrice);
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 下载批次报告
    downloadBatchReport (row) {
      const params = {
        SERVICE_ID: '10176',
        OTYPE: 4,
        Batch_Report_ID: row.BATCH_REPORT_ID,
      };
      http.post(params).then((res) => {
        if (res[0]) {
          // window.location.href = res[0].FILE_URL;
          const temp = document.createElement('a');
          const path = res[0].FILE_URL.lastIndexOf('/');
          temp.download = res[0].FILE_URL.substr(path + 1);
          temp.href = res[0].FILE_URL;
          temp.click();
        }
      });
    },
  },
  beforeRouteLeave (to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter (to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从历史订单列表进入订单详情', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.queryOrderDetailListData();
        that.queryBeforeFun();
      }
    });
  },
  destroyed () {
    bus.$emit('submit', this.tableData);
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/supplierCusHisOrderDetail.vue